import { __ } from '../utils';
import { Link } from './Link';
import { Button, Dialog, Stack, Typography } from '@presov.sk/presov-ui-react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

type ReportCreateResultModalProps = {
  open: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  message?: string;
  shouldRedirectOnClose?: boolean;
  onRetry?: () => void;
  reportId?: string;
  successText?: string;
  successHref?: string;
};

const ReportCreateResultModal: React.FC<ReportCreateResultModalProps> = ({
  open,
  onClose,
  type,
  message,
  shouldRedirectOnClose = true,
  onRetry,
  reportId,
  successText,
  successHref,
}) => {
  const isSuccess = type === 'success';

  return (
    <Dialog disableEscapeKeyDown open={open} onClose={onClose}>
      <Stack alignItems='center' justifyContent='center' gap={2} m={4}>
        {isSuccess ? (
          <CheckCircleOutlineIcon
            sx={{ fontSize: 64, color: 'success.main' }}
          />
        ) : (
          <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />
        )}

        <Stack>
          <Typography variant='h4' textAlign='center'>
            {message ||
              (isSuccess
                ? __('Ďakujeme za váš podnet')
                : __('Nastala chyba'))}
          </Typography>
          {!isSuccess && (
            <Typography variant='body1' textAlign='center' mt={2}>
              {__('Skúste prosím odoslať podnet znova.')}
            </Typography>
          )}
          {isSuccess && reportId && (
            <Typography variant='body1' textAlign='center' mt={1}>
              {__('Podnet bol vytvorený pod ID')}{' '}
              <Typography component='span' fontWeight='bold'>
                {reportId}
              </Typography>
            </Typography>
          )}
        </Stack>

        {isSuccess ? (
          shouldRedirectOnClose ? (
            <Link to={successHref ?? '/'}>
              <Button color='primary' size='large' onClick={onClose}>
                {successText ?? __('Prejsť na domovskú stránku')}
              </Button>
            </Link>
          ) : (
            <Button color='primary' size='large' onClick={onClose}>
              {__('Zavrieť')}
            </Button>
          )
        ) : (
          <Stack alignItems={'center'} gap={1}>
            {onRetry && (
              <Button color='primary' size='large' onClick={onRetry} fullWidth>
                {__('Zopakovať vytvorenie podnetu')}
              </Button>
            )}
            <Button
              fullWidth
              color='primary'
              variant='outlined'
              size='large'
              onClick={onClose}
            >
              {__('Zrušiť')}
            </Button>
          </Stack>
        )}
      </Stack>
    </Dialog>
  );
};

export default ReportCreateResultModal;
